import React from 'react';

import { Link } from '@opendoor/bricks-next';

import { useT } from 'helpers/i18n';

interface LoginSectionProps {
  showLogin: boolean;
}

export const LoginSection: React.FC<LoginSectionProps> = ({ showLogin }) => {
  const { t } = useT();

  if (!showLogin) return null;

  return (
    <Link
      href={'#'}
      fontWeight="$medium"
      analyticsName="cosmos-sign-in"
      aria-label="Sign in to your account"
      color="$contentPrimary"
    >
      {t('homepage.titles.signIn', 'Sign in')}
    </Link>
  );
};
